import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button as Button$1 } from '@crossroads/ui-components';

var _excluded = ["to", "children"];
var Button = _ref => {
  var _ref$to = _ref.to,
      to = _ref$to === void 0 ? "" : _ref$to,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (to.length > 0) {
    return /*#__PURE__*/React.createElement(Link, {
      to: to,
      style: {
        textDecoration: "none"
      }
    }, /*#__PURE__*/React.createElement(Button$1, props, children));
  }

  return /*#__PURE__*/React.createElement(Button$1, props, children);
};

export { Button };
//# sourceMappingURL=index.js.map
